import React from 'react';
import { Modal } from 'react-bootstrap';
import RMButton from './RMButton';

function RMCustomModal({
  showModal,
  setShowModal,
  body,
  heading,
  icon = null,
  titleClr = '#F7A246',
  buttonsList,
  dialogClassName = '',
}) {
  return (
    <Modal
      id={`controls-rmcustommodal-wrapper`}
      data-testid={`controls-rmcustommodal-wrapper`}
      backdrop="static"
      keyboard={false}
      show={showModal}
      onHide={() => {
        setShowModal(false);
      }}
      style={{ borderRadius: '6px' }}
      dialogClassName={dialogClassName}
    >
      <Modal.Header
        id={`controls-rmcustommodal-header-${heading}`}
        data-testid={`controls-rmcustommodal-header-${heading}`}
        style={{
          color: titleClr,
          fontWeight: 'bold',
          fontSize: '1.25rem',
          display: 'inline',
        }}
      >
        {icon ? (
          <>
            <img
              id="controls-rmcustommodal-header-icon"
              data-testid="controls-rmcustommodal-header-icon"
              src={icon}
              height={25}
              width={25}
            />
            &ensp;
          </>
        ) : null}
        {heading}
      </Modal.Header>
      <Modal.Body
        id={`controls-rmcustommodal-body`}
        data-testid={`controls-rmcustommodal-body`}
        style={{
          fontSize: '1.125rem',
          padding: '0 1rem',
          whiteSpace: 'pre-wrap',
        }}
      >
        {body}
      </Modal.Body>

      {buttonsList.length != 0 ? (
        <div
          id="controls-rmcustommodal-buttons-wrapper"
          data-testid="controls-rmcustommodal-buttons-wrapper"
          style={{
            display: 'flex',
            flexDirection: 'row',
            padding: '0 1rem',
            marginBottom: '1vh',
            justifyContent: 'flex-end',
            alignItems: 'flex-end',
          }}
        >
          {buttonsList.map((item, index) => (
            <RMButton
              id={`controls-rmcustommodal-button-${index}`}
              data-testid={`controls-rmcustommodal-button-${index}`}
              key={`rmcustomBUTTON-${index}`}
              className="btn-outline-yellow-wide"
              customStyle={{
                marginRight: index != buttonsList.lenght ? '0.4vw' : null,
              }}
              onClick={item.onClick}
            >
              {item.buttonText}
            </RMButton>
          ))}
        </div>
      ) : null}
    </Modal>
  );
}

export default RMCustomModal;
